import axios from "axios";
import * as END_POINTS from "../config/constants/end-points";

const om = {
  turnos: {
    // confirmar es para Empresas
    confirmar: body => {
      return axios.post(END_POINTS.CONFIRMAR, body);
    },
    getCitas: body => {
      return axios.post(END_POINTS.GET_CITAS, body);
    },
    getSucursales: body => {
      return axios.post(END_POINTS.GET_SUCURSALES, body);
    },
    getTramites: body => {
      return axios.post(END_POINTS.GET_TRAMITES, body);
    },
    getDias: body => {
      return axios.post(END_POINTS.GET_DIAS, body);
    },
    getHoras: body => {
      return axios.post(END_POINTS.GET_HORAS, body);
    },
    crearTurno: body => {
      return axios.post(END_POINTS.CREAR_TURNO, body);
    }
  }
};

export default om;
